import React, { ReactNode } from 'react';
import AppContext from '../AppContext';

interface AppContextProviderProps {
    withEnglishBAL?: boolean;
    children?: ReactNode;
}

const AppContextProvider = ({ withEnglishBAL = false, children }: AppContextProviderProps) => (
    <AppContext.Provider value={{ withEnglishBAL }}>{children}</AppContext.Provider>
);

export default AppContextProvider;
